<template>
  <div class="w-screen h-[90vh] relative overflow-hidden">
    <div v-for="(slide, index) in slides" :key="index">
      <transition name="slide">
        <div v-show="currentSlide === index" class="absolute inset-0 w-screen">
          <img
            v-if="showTagline"
            src="/img/cw-marketing/hero-text.png"
            alt="Finding a career should be an adventure"
            class="absolute top-20 left-10 w-72 lg:top-[45%] lg:left-[50%]"
          />

          <div class="relative w-full h-full">
            <img
              :src="slide.image"
              class="w-full h-full object-cover object-bottom"
            />
            <div
              v-if="showGradient"
              class="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent via-transparent"
            />
          </div>
          <!-- Ping animaition -->
          <div v-if="ping" class="absolute bottom-2 left-0 w-full h-28">
            <div
              v-for="i in 4"
              :key="i"
              :style="[
                { left: Math.random() * 100 + '%' },
                { bottom: Math.random() * 50 + '%' },
              ]"
              class="absolute flex justify-center items-center"
            >
              <span
                :class="'h-' + i + ' w-' + i"
                class="animate-ping absolute rounded-full opacity-75 bg-green-600"
              ></span>
              <span
                class="relative inline-flex rounded-full w-1"
                :style="{ backgroundColor: '#D9EE9C', height: '2px' }"
              ></span>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div
          v-show="currentSlide === index"
          class="absolute bottom-24 left-12 text-white pr-12"
        >
          <h1
            class="font-montserrat text-left font-black text-5xl mb-0 w-full lg:w-2/3"
          >
            {{ slide.title }}
          </h1>
          <h1
            v-if="slide.title2"
            class="font-montserrat text-left font-black text-5xl w-full lg:w-2/3"
          >
            {{ slide.title2 }}
          </h1>
          <p v-if="slide.text" class="text-base text-left pb-6 w-full lg:w-3/5">
            {{ slide.text }}
          </p>
          <p
            v-if="slide.html"
            class="text-lg text-left pb-6 mt-5 w-full lg:w-3/5"
            v-html="slide.html"
          />
          <button
            v-if="slide.btnTarget"
            class="btn btn-cw-alt font-nunito shadow-lg"
            @click="$router.push(slide.btnTarget)"
          >
            {{ slide.btnText }}
          </button>
        </div>
      </transition>
    </div>
    <template v-if="controls">
      <div class="hidden lg:block">
        <div
          class="absolute inset-y-1/2 cursor-pointer text-white left-8 opacity-20 hover:opacity-100 w-16 h-16"
          @click="prev()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8z"
            />
            <path
              fill="currentColor"
              d="M13.293 7.293 8.586 12l4.707 4.707 1.414-1.414L11.414 12l3.293-3.293-1.414-1.414z"
            />
          </svg>
        </div>
        <div
          class="absolute inset-y-1/2 cursor-pointer text-white right-8 opacity-20 hover:opacity-100 w-16 h-16"
          @click="next()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8z"
            />
            <path
              fill="currentColor"
              d="M9.293 8.707 12.586 12l-3.293 3.293 1.414 1.414L15.414 12l-4.707-4.707-1.414 1.414z"
            />
          </svg>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      required: true,
    },

    controls: {
      type: Boolean,
      default: false,
    },

    interval: {
      type: Number,
      default: 4000,
    },

    ping: {
      type: Boolean,
      default: false,
    },

    showTagline: {
      type: Boolean,
      default: true,
    },

    showGradient: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentSlide: 0,
      slideInterval: null,
      direction: 'right',
    }
  },

  computed: {
    transitionEffect() {
      return this.direction === 'right' ? 'slide-out' : 'slide-in'
    },
  },

  mounted() {
    this.startSlideTimer()
  },

  unmounted() {
    this.stopSlideTimer()
  },

  beforeUnmount() {
    clearInterval(this.timer)
  },

  methods: {
    setCurrentSlide(index) {
      this.currentSlide = index
    },

    prev(step = -1) {
      const index =
        this.currentSlide > 0
          ? this.currentSlide + step
          : this.slides.length - 1
      this.setCurrentSlide(index)
      this.direction = 'left'
      this.startSlideTimer()
    },

    _next(step = 1) {
      const index =
        this.currentSlide < this.slides.length - 1
          ? this.currentSlide + step
          : 0
      this.setCurrentSlide(index)
      this.direction = 'right'
    },

    next(step = 1) {
      this._next(step)
      this.startSlideTimer()
    },

    startSlideTimer() {
      this.stopSlideTimer()
      this.slideInterval = setInterval(() => {
        this._next()
      }, this.interval)
    },

    stopSlideTimer() {
      clearInterval(this.slideInterval)
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&display=swap');

/* Slide effect : Hero  */

.slide-in-enter-active,
.slide-in-leave-active,
.slide-out-enter-active,
.slide-out-leave-active {
  transition: all 1s ease-in-out;
}

.slide-in-enter-from {
  transform: translateX(-100%);
}

.slide-in-leave-to {
  transform: translateX(100%);
}

.slide-out-enter-from {
  transform: translateX(100%);
}

.slide-out-leave-to {
  transform: translateX(-100%);
}

/* Fade effect : Hero Text box  */
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-active {
  opacity: 1;
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>
